import { useEffect, useRef } from "react";
import { MODE_DRAWS, resolvePreset } from "thinking-orbs";

// The marketing canvas engine is bundled locally; no runtime asset fetch.
export function CheckoutOrb() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas?.getContext("2d");
    if (!canvas || !context) return;
    const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const { mode, speed, opts } = resolvePreset("searching", 64);
    const draw = MODE_DRAWS[mode];
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    canvas.width = canvas.height = Math.round(800 * dpr);
    const scale = (800 / 64) * dpr;
    let frameId = 0;
    const frame = (seconds: number) => {
      context.setTransform(scale, 0, 0, scale, 0, 0);
      context.clearRect(0, 0, 64, 64);
      draw(context, 64, seconds * speed * 0.35, true, opts);
      context.globalCompositeOperation = "source-atop";
      context.globalAlpha = 0.85;
      context.fillStyle = "#99d4ad";
      context.fillRect(0, 0, 64, 64);
      context.globalCompositeOperation = "source-over";
      context.globalAlpha = 1;
    };
    const tick = () => {
      frame(window.performance.now() / 1000);
      frameId = window.requestAnimationFrame(tick);
    };
    const sync = () => {
      window.cancelAnimationFrame(frameId);
      if (motion.matches) frame(0.6);
      else if (document.visibilityState !== "hidden") tick();
    };
    sync();
    motion.addEventListener("change", sync);
    document.addEventListener("visibilitychange", sync);
    return () => {
      window.cancelAnimationFrame(frameId);
      motion.removeEventListener("change", sync);
      document.removeEventListener("visibilitychange", sync);
    };
  }, []);
  return <canvas className="marker-checkout-orb" ref={canvasRef} />;
}
